import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { BASE_URL } from '../../api/baseURL';
import { axiosBaseQuery } from '../axiosBaseQuery';
import { IActivity, IAnalytics } from './interface';
import { PaginatedResponse, Response } from '../genericInterface';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL
  }),
  tagTypes: ['activities'],
  endpoints: (builder) => ({
    getWeeklyActivities: builder.query<PaginatedResponse<IActivity>, string>({
      query: (query) => ({
        url: `/activity/get-weekly-activities?${query}`,
        method: 'GET'
      }),
      providesTags: (_, __, query) => [{ type: 'activities', id: query }]
    }),
    getAnalytics: builder.query<Response<IAnalytics>, void>({
      query: (query) => ({
        url: `/activity/total-expenses`,
        method: 'GET'
      })
      // providesTags: (_, __, query) => [{ type: 'activities', id: query }]
    })
  })
});

export const { useGetWeeklyActivitiesQuery, useGetAnalyticsQuery } =
  dashboardApi;
